import * as angular from "angular";
import * as _ from "lodash";
import {ServiceAreasServiceType} from "../../service-areas/angular/types/service-areas-service.type";
import {$agentsFactory} from "../../agents/$agents.factory";
import {ResourcesService} from "./resources-service.service";
import {SplitService} from "../../commons/services/split-service.service";
import {ResourceSkill} from "../../agents/types/resourceSkill.type";
import {AgentType} from "../../agents/types/agent.type";
import {ResourceAllocationEditType} from "../types/resourceAllocationEdit.type";
import {unset} from "lodash";

export class ResourcesDialogService {

  /* @ngInject */
  constructor(private $mdDialog, private moment, private $log, private splitService: SplitService) {
  }

  // ******************************
  // Public methods
  // ******************************

  createResource(branchIds, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/resource-dialog.html').default,
      controller: function ($scope, agentConstants, planningConstants) {

        // $scope.isEnableResourceAgentTypeEditing = true;
        // $scope.agentTypes = agentConstants.types;
        // $scope.locationTypes = planningConstants.locationTypes;
        // $scope.skillsTypes = agentConstants.skillsByType['ServiceAgent'];
        // $scope.serviceAreaTypes = [ServiceAreasServiceType.Planning];
        // $scope.isSupportResourcePriority = this.splitService.getSupportResourcePriority();
        // $scope.limitingSingleTimezone = this.splitService.getLimitingSingleTimezone();
        // $scope.skillOptions = [ResourceSkill.Delivery, ResourceSkill.Merchandise, ResourceSkill.Order, ResourceSkill.AutonomousAgent];

        $scope.resource = {
          name: undefined,
          agentType: agentConstants.types[0],
          requiredSkills: [agentConstants.skillsByType[agentConstants.types[0]][0]],
          externalId: undefined,
          vehicleId: undefined,
          carrierId: undefined,
          agentId: undefined,
          gapInMinutes: undefined,
          branchIds: branchIds || undefined,
          serviceAreaIds: [],
          tags: [],
          isActive: true,
          disableRetrips: false,
          optimizeStart: undefined,
          optimizeStartBufferMinutes: undefined,
          zoneId: self.splitService.getSelectedTimeZone(),
          // capacity: {
          //   numberOfStops: undefined
          // },
          locationSettings: undefined
        };
        // $scope.logisticsVehicleTypeIds = undefined;
        //
        $scope.header = 'Create New Resource';
        // $scope.action = 'Create';

        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////////

        // ******************************
        //        Public methods
        // ******************************

        $scope.onSubmit = (resource) => {
          self.$mdDialog.hide(resource);
        }

        // $scope.onTimeZoneChange = (zoneId) => {
        //   $scope.resource.zoneId = zoneId;
        // }
        //
        // $scope.onAgentTypeChange = (agentType) => {
        //   $scope.resource.agentType = agentType;
        //   $scope.resource.agentId = undefined;
        //   $scope.resource.requiredSkills = agentConstants.skillsByType[agentType];
        // }
        //
        // $scope.onSkillSelect = (skills) => {
        //   $scope.resource.requiredSkills = skills;
        // }
        //
        // $scope.onVehicleSelect = (vehicle) => {
        //   $scope.resource.vehicle = vehicle;
        //   $scope.resource.vehicleId = _.get(vehicle, 'id');
        //   $scope.resource.mainLogisticsVehicleId = undefined;
        //   $scope.logisticsVehicleTypeIds = _.get(vehicle, 'id') ? [vehicle.id] : [];
        // }
        //
        // $scope.onLogisticsVehicleSelect = (logisticsVehicle) => {
        //   $scope.resource.mainLogisticsVehicleId = _.get(logisticsVehicle, 'id');
        // }
        //
        // $scope.onAttachedLogisticsVehicleSelect = (ids) => {
        //   $scope.resource.attachedLogisticsVehicleIds = ids;
        // }
        //
        // $scope.onBranchIdsChange = (branchIds) => {
        //   $scope.resource.branchIds = branchIds;
        // }
        //
        // $scope.onSelectServiceAreas = (serviceAreaIds) => {
        //   $scope.resource.serviceAreaIds = serviceAreaIds;
        // }
        //
        // $scope.onSelectCarrier = (account) => {
        //   if (account?.id !== $scope.resource.carrierId) {
        //     $scope.resource.agentId = undefined;
        //   }
        //   $scope.resource.carrierId = _.get(account, 'id');
        // }
        //
        // $scope.onSelectDefaultAgent = (agentBinding) => {
        //   $scope.resource.agentId = _.get(agentBinding, 'id');
        // }
        //
        // $scope.onResourcePriorityChange = (priority) => {
        //   $scope.resource.priority = priority;
        // }
        //
        // $scope.onLocationSettingsChange = (locationSettings) => {
        //   $scope.resource.locationSettings = locationSettings;
        // }
        //
        // $scope.onToggleBlock = () => {
        //   $scope.resource.isActive = !$scope.resource.isActive;
        //
        //   if (!$scope.resource.isActive) {
        //     $scope.resource.blockManualRoute = true;
        //     $scope.resource.blockPlanningRoute = true;
        //     $scope.resource.blockQuoteRoute = true;
        //   } else {
        //     $scope.resource.blockManualRoute = false;
        //     $scope.resource.blockPlanningRoute = false;
        //     $scope.resource.blockQuoteRoute = false;
        //   }
        // }
        //
        // $scope.onToggleBlockResource = (resourceType) => {
        //   $scope.resource[resourceType] = !$scope.resource[resourceType];
        //   $scope.resource.isActive = !$scope.resource.blockManualRoute || !$scope.resource.blockPlanningRoute || !$scope.resource.blockQuoteRoute
        // }
        //
        // $scope.submit = (form) => {
        //   if (form) {
        //     form.$setSubmitted(true);
        //     if (form.$valid) {
        //       if (!$scope.resource.zoneId) {
        //         $scope.resource.zoneId = this.moment.tz.guess()
        //       }
        //       this.$mdDialog.hide($scope.resource);
        //     }
        //
        //   }
        // }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  editResource(resource, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/resource-dialog.html').default,
      controller: function ($scope, planningConstants, agentConstants) {

        // $scope.isEnableResourceAgentTypeEditing = this.splitService.getEnableResourceAgentTypeEditing();
        // $scope.locationTypes = planningConstants.locationTypes;
        // $scope.serviceAreaTypes = [ServiceAreasServiceType.Planning];
        // $scope.logisticsVehicleTypeIds = _.get(resource, 'vehicle.id') ? [resource.vehicle.id] : [];
        // $scope.isSupportResourcePriority = this.splitService.getSupportResourcePriority();
        // $scope.limitingSingleTimezone = this.splitService.getLimitingSingleTimezone();
        // $scope.skillOptions = [ResourceSkill.Delivery, ResourceSkill.Merchandise, ResourceSkill.Order, ResourceSkill.AutonomousAgent];
        // $scope.enableAllocationBranchSupport = this.splitService.getEnableAllocationBranchSupport();
        // $scope.canAddServiceAreasToTw = false;
        // $scope.addServiceAreasToTw = {
        //   enabled: false
        // };
        //
        // $scope.autoUpdateAllocationBranches = {
        //   enabled: false
        // };

        $scope.resource = angular.copy(resource);

        // if (!_.get($scope.resource, 'branchIds')) {
        //   $scope.resource.branchIds = undefined;
        // }

        $scope.header = 'Edit Resource';
        $scope.isEdit = true;

        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////////

        // ******************************
        //        Public methods
        // ******************************

        $scope.onSubmit = (updatedResource, addServiceAreasToTw?, autoUpdateAllocationBranches?) => {
          const payload = {
            resource: updatedResource,
            addServiceAreasToTw,
            autoUpdateAllocationBranches
          };
          self.$mdDialog.hide(payload);
        }

        // $scope.onTimeZoneChange = (zoneId) => {
        //   $scope.resource.zoneId = zoneId;
        // }
        //
        // $scope.onAgentTypeChange = (agentType) => {
        //   $scope.resource.agentType = agentType;
        //   $scope.resource.agentId = undefined;
        //   $scope.resource.requiredSkills = agentConstants.skillsByType[agentType];
        // }
        //
        // $scope.onSkillSelect = (skills) => {
        //   $scope.resource.requiredSkills = skills;
        // }
        //
        // $scope.onVehicleSelect = (vehicle) => {
        //   $scope.resource.vehicle = vehicle;
        //   $scope.resource.vehicleId = _.get(vehicle, 'id');
        //   $scope.resource.mainLogisticsVehicleId = undefined;
        //   $scope.logisticsVehicleTypeIds = _.get(vehicle, 'id') ? [vehicle.id] : [];
        // }
        //
        // $scope.onLogisticsVehicleSelect = (logisticsVehicle) => {
        //   $scope.resource.mainLogisticsVehicleId = _.get(logisticsVehicle, 'id');
        // }
        //
        // $scope.onAttachedLogisticsVehicleSelect = (ids) => {
        //   $scope.resource.attachedLogisticsVehicleIds = ids;
        // }
        //
        // $scope.onBranchIdsChange = (branchIds) => {
        //   $scope.resource.branchIds = branchIds;
        //   $scope.resource.agentId = undefined;
        //
        //   $scope.isBranchesChagned = !!_.difference($scope.resource.branchIds, resource.branchIds).length;
        // }
        //
        // $scope.onSelectServiceAreas = (serviceAreasIds) => {
        //   $scope.resource.serviceAreaIds = serviceAreasIds;
        //   $scope.canAddServiceAreasToTw = !!_.difference($scope.resource.serviceAreaIds, resource.serviceAreaIds).length;
        // }
        //
        // $scope.onSelectCarrier = (account) => {
        //   if (account?.id !== $scope.resource.carrierId) {
        //     $scope.resource.agentId = undefined;
        //   }
        //   $scope.resource.carrierId = _.get(account, 'id');
        // }
        //
        // $scope.onSelectDefaultAgent = (agentBinding) => {
        //   $scope.resource.agentId = _.get(agentBinding, 'id');
        // }
        //
        // $scope.onLocationSettingsChange = (locationSettings) => {
        //   $scope.resource.locationSettings = locationSettings;
        // }
        //
        // $scope.onResourcePriorityChange = (priority) => {
        //   $scope.resource.priority = priority;
        // }
        //
        // $scope.onToggleBlock = () => {
        //   $scope.resource.isActive = !$scope.resource.isActive;
        //
        //   if (!$scope.resource.isActive) {
        //     $scope.resource.blockManualRoute = true;
        //     $scope.resource.blockPlanningRoute = true;
        //     $scope.resource.blockQuoteRoute = true;
        //   } else {
        //     $scope.resource.blockManualRoute = false;
        //     $scope.resource.blockPlanningRoute = false;
        //     $scope.resource.blockQuoteRoute = false;
        //   }
        // }
        //
        // $scope.onToggleBlockResource = (resourceType) => {
        //   $scope.resource[resourceType] = !$scope.resource[resourceType];
        //   $scope.resource.isActive = !$scope.resource.blockManualRoute || !$scope.resource.blockPlanningRoute || !$scope.resource.blockQuoteRoute
        // }
        //
        // $scope.submit = (form) => {
        //   if (form) {
        //     form.$setSubmitted(true);
        //     if (form.$valid) {
        //       const payload = {
        //         resource: $scope.resource,
        //         addServiceAreasToTw: $scope.canAddServiceAreasToTw ? $scope.addServiceAreasToTw.enabled : undefined,
        //         autoUpdateAllocationBranches: $scope.enableAllocationBranchSupport && $scope.isBranchesChagned ? $scope.autoUpdateAllocationBranches.enabled : undefined
        //       };
        //       this.$mdDialog.hide(payload);
        //     }
        //
        //   }
        // }

        // ******************************
        // External methods
        // ******************************


      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  duplicateResource(resource, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/resource-duplicate-dialog.html').default,
      controller: function ($scope, planningConstants) {

        $scope.resource = angular.copy(resource);
        $scope.name = _.get(resource, 'name') + ' Copy';
        $scope.externalId = undefined;

        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////////

        // ******************************
        //        Public methods
        // ******************************

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide({name: $scope.name, externalId: $scope.externalId});
            }

          }
        }

        // ******************************
        // External methods
        // ******************************


      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  createResourceAllocation(resource, date, branchIds, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/add-allocation-to-resource-dialog.html').default,
      controller: function ($scope, commonsConstants, resourcesConstants) {

        var rrule = require('rrule');
        var dowNames = commonsConstants.dayArray;

        $scope.header = 'Create New Allocation';
        $scope.isEdit = false;

        $scope.days = angular.copy(commonsConstants.daysCheckboxConfig);
        $scope.rruleTypes = commonsConstants.rruleTypes;

        $scope.resource = resource;

        $scope.serviceAreasServiceTypes = [ServiceAreasServiceType.Planning];

        $scope.recurringType = undefined;
        $scope.isBulkWeekly = {
          enabled: false
        };

        $scope.serviceAreaOptionIds = _.get(resource, 'serviceAreaIds');
        $scope.branchIds = branchIds;
        $scope.extraTimeInMinutes = _.get($scope.allocation, 'extraTimeInMillis') / 60000 || undefined;

        $scope.allocation = {
          resourceAllocationId: resource.id,
          schedule: {
            startTime: self.moment(date).startOf('day').valueOf(),
            endTime: self.moment(date).hour(23).minute(45).second(0).millisecond(0).valueOf()
          },
          locationSettings: undefined,
          extraTimeInMillis: undefined,
          gapInMinutes: undefined,
          details: [],
          serviceAreaIds: _.get(resource, 'serviceAreaIds', []),
          branchIds: branchIds,
          segments: []
        };
        // onAddSegment();

        $scope.serviceAreasPriorities = resourcesConstants.serviceAreasPriorities;

        $scope.sequenceSectionOpen = false; //allocation.details.length

        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////////

        // ******************************
        //        Public methods
        // ******************************

        $scope.onRangeChange = (from, to) => {
          $scope.allocation.schedule.startTime = from;
          $scope.allocation.schedule.endTime = to;
        }

        $scope.onExtraTimeChange = (extraTimeInMinutes) => {
          const extraTimeInMillis = extraTimeInMinutes * 60000;
          $scope.allocation.extraTimeInMillis = extraTimeInMillis;
        }

        $scope.onRecurringChange = (recurringType) => {
          $scope.recurringType = recurringType;
          $scope.isBulkWeekly = {
            enabled: false
          };
        }

        $scope.onSegmentFromChange = (fromTime, segmentId) => {
          const diffOffset = fromTime - $scope.allocation.schedule.startTime;

          const segmentIdx = _.findIndex($scope.allocation.segments, (s: any) => {
            return s.id === segmentId;
          });

          $scope.allocation.segments[segmentIdx].offsetInMillis = diffOffset;
        }

        $scope.onSegmentToChange = (toTime, segmentId) => {
          const segmentIdx = _.findIndex($scope.allocation.segments, (s: any) => {
            return s.id === segmentId;
          });

          let diffDuration = toTime - $scope.allocation.segments[segmentIdx].offsetInMillis - $scope.allocation.schedule.startTime;

          $scope.allocation.segments[segmentIdx].durationInMillis = diffDuration;
        }

        $scope.onSetSegmentDurationInMillis = (durationInMinutes, segmentId) => {
          const segmentIdx = _.findIndex($scope.allocation.segments, (s: any) => {
            return s.id === segmentId;
          });

          const durationInMillis = durationInMinutes * 60000;
          $scope.allocation.segments[segmentIdx].durationInMillis = durationInMillis;
        }

        $scope.onAddSegment = (index, event) => {

          let offSetToAdd: number = 0
          let durationToAdd: number = 0
          let priorityToAdd = undefined;

          if (index) {
            const prevSegment = _.get($scope.allocation, `segments[${index - 1}]`);
            const nextSegment = _.get($scope.allocation, `segments[${index}]`);
            offSetToAdd = _.get(prevSegment, 'offsetInMillis', 0) + _.get(prevSegment, 'durationInMillis', 0);
            durationToAdd = nextSegment ? _.get(nextSegment, 'offsetInMillis') - offSetToAdd : _.get(prevSegment, 'durationInMillis', undefined);
            if (durationToAdd === 0) {
              durationToAdd = _.get(prevSegment, 'durationInMillis', undefined)
            }
            priorityToAdd = _.get(prevSegment, `planningAreas[${_.get(prevSegment, 'planningAreas.length') - 1}].priority`, undefined)
          }

          const newSegment = {
            id: self.moment().valueOf().toString(),
            offsetInMillis: offSetToAdd,
            durationInMillis: durationToAdd,
            planningAreas: [
              {
                id: self.moment().valueOf(),
                areaId: undefined,
                priority: priorityToAdd
              }
            ]
          }

          _.get($scope.allocation, 'segments').splice(index, 0, newSegment);
          $scope.allocation.segments = angular.copy($scope.allocation.segments);
        }

        $scope.onAddServiceArea = (segmentId, event) => {
          const newServiceArea = {
            id: (Date.now()).toString(),
            areaId: undefined,
            priority: undefined
          }

          const segmentIdx = _.findIndex($scope.allocation.segments, (s: any) => {
            return s.id === segmentId;
          });

          $scope.allocation.segments[segmentIdx].planningAreas.push(newServiceArea);
        }

        $scope.onRemoveServiceArea = (segmentId, areaId, event) => {
          const segmentIdx = _.findIndex($scope.allocation.segments, (s: any) => {
            return s.id === segmentId;
          });

          const areaIdx = _.findIndex($scope.allocation.segments[segmentIdx].planningAreas, (a: any) => {
            return a.id === areaId;
          });

          $scope.allocation.segments[segmentIdx].planningAreas.splice(areaIdx, 1);
        }

        $scope.onRemoveSegment = (segmentId, $event) => {
          const segmentIdx = _.findIndex($scope.allocation.segments, (s: any) => {
            return s.id === segmentId;
          });

          $scope.allocation.segments.splice(segmentIdx, 1);
        }

        $scope.onSelectServiceAreas = (serviceAreasIds) => {
          $scope.allocation.serviceAreaIds = serviceAreasIds;
        }

        $scope.onAccountSelect = (account, sequenceDetails, $index) => {
          if (account) {
            sequenceDetails.holderId = account.id;
          }
        }

        $scope.onAdd = () => {
          $scope.allocation.details.push({
            holderId: undefined,
            sequence: $scope.allocation.details.length + 1,
            type: "ACCOUNT"
          })
        }

        $scope.onRemove = ($index) => {
          $scope.allocation.details.splice($index, 1);
        }

        $scope.onLocationSettingsChange = (locationSettings) => {
          $scope.allocation.locationSettings = locationSettings;
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              var allocationsToCreate = [];
              var allocationCopy = angular.copy($scope.allocation);
              var isWeekly = _.isEqual(_.get($scope.recurringType, 'value'), 'RRule.WEEKLY');
              var weekDays = isWeekly ? _.filter($scope.days, (value, key) => {
                return value.enabled;
              }) : [];
              allocationCopy.schedule.zoneIdName = self.splitService.getTimeZone();

              if ($scope.recurringType) {
                var roleTest = new rrule.RRule({
                  freq: _.get(rrule, $scope.recurringType.value),
                  dtstart: self.moment($scope.allocation.schedule.startTime).toDate(),
                  // until: moment($scope.timeConfig.to.date).toDate(),
                  interval: 1
                });
                allocationCopy.schedule.rrule = roleTest.toString();
                allocationCopy.schedule.interval = 1;
                allocationCopy.schedule.freq = $scope.recurringType.value.substr(6);
                allocationCopy.schedule.startRecurring = $scope.allocation.schedule.startTime;

                _.forEach(allocationCopy.details, (allocationDetail, i) => {
                  allocationDetail.sequence = i + 1;
                })

                if ($scope.isBulkWeekly.enabled) {
                  _.forEach(_.map(weekDays, 'key'), (wd) => {
                    var allocationBulkCopy = angular.copy(allocationCopy)
                    allocationBulkCopy.schedule.byWeekDay = [wd];
                    allocationsToCreate.push(allocationBulkCopy);
                  })
                } else {
                  if (allocationCopy.schedule.freq && _.isEqual(allocationCopy.schedule.freq, 'WEEKLY')) {
                    allocationCopy.schedule.byWeekDay = _.map(weekDays, 'key');
                  } else {
                    allocationCopy.schedule.byWeekDay = [];
                  }
                }
              }

              // if (_.get(allocationCopy, 'locationSettings.departurePointType') === 'UNDEFINED') {
              //   _.unset(allocationCopy, 'locationSettings.departurePointType');
              // }
              // if (_.get(allocationCopy, 'locationSettings.endPointType') === 'UNDEFINED') {
              //   _.unset(allocationCopy, 'locationSettings.endPointType');
              // }

              if (_.isEmpty(allocationsToCreate)) {
                allocationsToCreate.push(allocationCopy);
              }

              self.$mdDialog.hide(allocationsToCreate);
            }

          }
        }


      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  editResourceAllocation(allocation, resource, branchIds, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/add-allocation-to-resource-dialog.html').default,
      controller: function ($scope, commonsConstants, resourcesConstants) {

        var rrule = require('rrule');

        $scope.header = 'Update Allocation';
        $scope.isEdit = true;

        $scope.resource = resource;
        $scope.rruleTypes = commonsConstants.rruleTypes;

        $scope.serviceAreasServiceTypes = [ServiceAreasServiceType.Planning];

        $scope.sequenceSectionOpen = _.get(allocation, 'details.length', 0) > 0;

        $scope.allocation = angular.copy(allocation);
        $scope.extraTimeInMinutes = _.get($scope.allocation, 'extraTimeInMillis') / 60000 || undefined;

        $scope.allocation.details = _.sortBy($scope.allocation.details, ['sequence']);
        if (!$scope.allocation.details) {
          $scope.allocation.details = [];
        }

        $scope.serviceAreaOptionIds = _.get(resource, 'serviceAreaIds');
        $scope.branchIds = branchIds;

        $scope.allocation.segments = _.get($scope.allocation, 'segments');
        if (_.isUndefined($scope.allocation.segments)) {
          $scope.allocation.segments = [];
          // onAddSegment();
        }

        $scope.serviceAreasPriorities = resourcesConstants.serviceAreasPriorities;

        var ruleOptions = rrule.RRule.fromString(_.get(allocation, 'schedule.rrule') || '').origOptions;
        // $scope.recurringType = $scope.rruleTypes[ruleOptions.freq];
        $scope.recurringType = _.find($scope.rruleTypes, (t) => {
          return t.freq === ruleOptions.freq;
        });

        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////////

        // ******************************
        //        Public methods
        // ******************************

        $scope.onRangeChange = (from, to) => {
          $scope.allocation.schedule.startTime = from;
          $scope.allocation.schedule.endTime = to;
        }

        $scope.onExtraTimeChange = (extraTimeInMinutes) => {
          const extraTimeInMillis = extraTimeInMinutes * 60000;
          $scope.allocation.extraTimeInMillis = extraTimeInMillis;
        }

        $scope.onSelectServiceAreas = (serviceAreasIds) => {
          $scope.allocation.serviceAreaIds = serviceAreasIds;
        }

        $scope.onSegmentFromChange = (fromTime, segmentId) => {
          var diffOffset = fromTime - $scope.allocation.schedule.startTime;

          var segmentIdx = _.findIndex($scope.allocation.segments, (s: any) => {
            return s.id === segmentId;
          });

          $scope.allocation.segments[segmentIdx].offsetInMillis = diffOffset;
        }

        $scope.onSegmentToChange = (toTime, segmentId) => {
          const segmentIdx = _.findIndex($scope.allocation.segments, (s: any) => {
            return s.id === segmentId;
          });

          const diffDuration = toTime - $scope.allocation.segments[segmentIdx].offsetInMillis - $scope.allocation.schedule.startTime;
          $scope.allocation.segments[segmentIdx].durationInMillis = diffDuration;
        }

        $scope.onSetSegmentDurationInMillis = (durationInMinutes, segmentId) => {
          const segmentIdx = _.findIndex($scope.allocation.segments, (s: any) => {
            return s.id === segmentId;
          });

          const durationInMillis = durationInMinutes * 60000;
          $scope.allocation.segments[segmentIdx].durationInMillis = durationInMillis;
        }

        $scope.onAddSegment = () => {
          const newSegment = {
            id: (Date.now()).toString(),
            offsetInMillis: 0,
            // durationInMillis: ($scope.allocation.schedule.endTime - $scope.allocation.schedule.startTime),
            durationInMillis: undefined,
            planningAreas: [
              {
                id: (Date.now()).toString(),
                areaId: undefined,
                priority: undefined
              }
            ]
          }
          _.get($scope.allocation, 'segments').push(newSegment);
        }

        $scope.onAddServiceArea = (segmentId, event) => {
          const newServiceArea = {
            id: (Date.now()).toString(),
            areaId: undefined,
            priority: undefined
          }

          var segmentIdx = _.findIndex($scope.allocation.segments, (s: any) => {
            return s.id === segmentId;
          });

          $scope.allocation.segments[segmentIdx].planningAreas.push(newServiceArea);
        }

        $scope.onRemoveServiceArea = (segmentId, areaId, event) => {
          const segmentIdx = _.findIndex($scope.allocation.segments, (s: any) => {
            return s.id === segmentId;
          });

          const areaIdx = _.findIndex($scope.allocation.segments[segmentIdx].planningAreas, (a: any) => {
            return a.id === areaId;
          });

          $scope.allocation.segments[segmentIdx].planningAreas.splice(areaIdx, 1);
        }

        $scope.onRemoveSegment = (segmentId) => {
          const segmentIdx = _.findIndex($scope.allocation.segments, (s: any) => {
            return s.id === segmentId;
          });

          $scope.allocation.segments.splice(segmentIdx, 1);
        }

        $scope.onRecurringChange = (recurringType) => {
          $scope.recurringType = recurringType;
        }

        $scope.onAccountSelect = (account, sequenceDetails, $index) => {
          if (account) {
            sequenceDetails.holderId = account.id;
          }
        }

        $scope.onAdd = () => {
          if (!$scope.allocation.details) {
            $scope.allocation.details = [];
          }
          $scope.allocation.details.push({
            holderId: undefined,
            sequence: $scope.allocation.details.length + 1,
            type: "ACCOUNT"
          })
        }

        $scope.onRemove = ($index) => {
          $scope.allocation.details.splice($index, 1);
        }

        $scope.onLocationSettingsChange = (locationSettings) => {
          $scope.allocation.locationSettings = locationSettings;
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              var allocationCopy = angular.copy($scope.allocation);
              allocationCopy.schedule.zoneIdName = self.splitService.getTimeZone();

              if ($scope.recurringType) {
                var roleTest = new rrule.RRule({
                  freq: _.get(rrule, $scope.recurringType.value),
                  dtstart: self.moment($scope.allocation.schedule.startTime).toDate(),
                  // until: moment($scope.timeConfig.to.date).toDate(),
                  interval: 1
                });
                allocationCopy.schedule.rrule = $scope.recurringType ? roleTest.toString() : undefined;
                allocationCopy.schedule.interval = $scope.recurringType ? 1 : undefined;
                allocationCopy.schedule.freq = $scope.recurringType ? $scope.recurringType.value.substr(6) : undefined;
                // allocationCopy.schedule.startRecurring = $scope.recurringType ? $scope.allocation.schedule.startTime : undefined;

                if (allocationCopy.schedule.freq && !_.isEqual(allocationCopy.schedule.freq, 'DAILY')) {
                  allocationCopy.schedule.byWeekDay = [self.moment($scope.allocation.schedule.startTime).format('dd')];
                } else {
                  allocationCopy.schedule.byWeekDay = [];
                }

                _.forEach(allocationCopy.details, (allocationDetail, i) => {
                  allocationDetail.sequence = i + 1;
                })
              }

              // if (_.get(allocationCopy, 'locationSettings.departurePointType') === 'UNDEFINED') {
              //   _.unset(allocationCopy, 'locationSettings.departurePointType');
              // }
              // if (_.get(allocationCopy, 'locationSettings.endPointType') === 'UNDEFINED') {
              //   _.unset(allocationCopy, 'locationSettings.endPointType');
              // }

              self.$mdDialog.hide(allocationCopy);
            }

          }
        }


      },
      targetEvent: event,
      clickOutsideToClose: true
    })

  }

  resourceTypeSelect(event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/resource-type-select-dialog.html').default,
      controller: function ($scope) {

        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////////

        // ******************************
        //        Public methods
        // ******************************

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.payload);
            }

          }
        }
      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  attachAgentToAllocation(allocation, range, resource, branchIds, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/attach-agent-to-allocation-dialog.html').default,
      controller: function ($scope, resourcesService: ResourcesService, $agents: $agentsFactory) {
        $scope.resourceAllocationEditTypes = [
          ResourceAllocationEditType.EVENT,
          ResourceAllocationEditType.FUTURE,
          ResourceAllocationEditType.ALL
        ];
        $scope.editType = ResourceAllocationEditType.EVENT;

        $scope.allocation = angular.copy(allocation);
        $scope.isRequrring = !!allocation.templateId && !allocation.template && !allocation.overridden;
        $scope.allocationByRange = angular.copy(allocation)
        $scope.allocationByRange.schedule.startTime = range.from;
        $scope.allocationByRange.schedule.endTime = range.to;
        $scope.agentType = resource.agentType;
        $scope.resourceName = resource.name;

        $scope.loading = true;
        // $scope.allocation = allocation;
        // $scope.allocationRange = range;
        $scope.agentsSchedule = [];
        $scope.attachToAllRecurring = {
          enabled: false
        };

        $scope.ignoreSchedules = {
          enabled: false
        }

        $scope.queryString = undefined;

        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////////

        // ******************************
        //        Public methods
        // ******************************

        $scope.getAgentAllocationBindings = () => {
          resourcesService.getAgentAllocationBindings(range.from, range.to, resource.agentType, branchIds, $scope.ignoreSchedules.enabled)
            .then((agentsSchedule) => {
              $scope.agentsSchedule = agentsSchedule;
            })
            .finally(() => {
              $scope.loading = false;
            })
        }

        $scope.getAgentAllocationBindings();

        $scope.onQueryChange = (query) => {
          $scope.queryString = query;
        }

        $scope.onEditTypeChange = (editType) => {
          $scope.editType = editType;
        }

        $scope.onAssign = (agentBinding) => {
          const payload = {
            agentId: agentBinding.agentId,
            type: $scope.editType
          }

          self.$mdDialog.hide(payload);
        }
      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  attachAgentToAllocations(resource, allocations, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/attach-agent-to-allocations-dialog.html').default,
      controller: function ($scope, resourcesService: ResourcesService, $agents: $agentsFactory) {

        $scope.resourceAllocationEditTypes = [
          ResourceAllocationEditType.EVENT,
          ResourceAllocationEditType.FUTURE,
          ResourceAllocationEditType.ALL
        ];

        $scope.editType = ResourceAllocationEditType.EVENT;

        $scope.agentType = resource.agentType;
        $scope.branchIds = resource.branchIds;
        $scope.allocations = allocations;
        $scope.todayDate = self.moment().startOf('day').valueOf();
        $scope.range = {
          startTime: undefined,
          endTime: undefined
        };

        if (!!allocations?.length) {
          $scope.range.startTime = Math.min(...allocations.map(t => t.schedule.startTime));
          $scope.range.endTime = Math.max(...allocations.map(t => t.schedule.endTime));
        } else {
          $scope.range.startTime = self.moment().startOf('day').valueOf();
          $scope.range.endTime = self.moment().add(7, 'day').endOf('day').valueOf();
        }

        $scope.resourceName = resource.name;

        $scope.loading = true;
        $scope.agentsSchedule = [];
        $scope.attachToAllRecurring = {
          enabled: false
        };

        $scope.queryString = undefined;

        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////////

        // ******************************
        //        Public methods
        // ******************************

        // $scope.getAgentAllocationBindings = () => {
        //   resourcesService.getAgentAllocationBindings($scope.range.startTime, $scope.range.endTime, resource.agentType, resource.branchIds, true)
        //     .then((agentsSchedule) => {
        //       $scope.agentsSchedule = agentsSchedule;
        //     })
        //     .finally(() => {
        //       $scope.loading = false;
        //     })
        // }
        //
        // $scope.getAgentAllocationBindings();

        $scope.onFromDateRangeChange = (date) => {
          $scope.range.startTime = self.moment(date).startOf('day').valueOf();
          // $scope.getAgentAllocationBindings();
        }

        $scope.onToDateRangeChange = (date) => {
          $scope.range.endTime = self.moment(date).endOf('day').valueOf();
          // $scope.getAgentAllocationBindings();
        }

        $scope.onEditTypeChange = (editType) => {
          $scope.editType = editType;
        }


        $scope.onQueryChange = (query) => {
          $scope.queryString = query;
        }

        $scope.onAssign = (agent) => {
          const payload = {
            agentId: agent.id,
            type: $scope.editType,
            range: $scope.range
          }

          self.$mdDialog.hide(payload);
        }
      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  detachAgentToAllocation(allocation, range, resource, branchIds, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/detach-agent-to-allocation-dialog.html').default,
      controller: function ($scope, resourcesService: ResourcesService, $agents: $agentsFactory) {
        $scope.resourceAllocationEditTypes = [
          ResourceAllocationEditType.EVENT,
          ResourceAllocationEditType.FUTURE,
          ResourceAllocationEditType.ALL
        ];
        $scope.editType = ResourceAllocationEditType.EVENT;

        $scope.isRequrring = !!allocation.templateId && !allocation.template && !allocation.overridden;
        $scope.agentType = resource.agentType;
        $scope.resourceName = resource.name;

        $scope.loading = true;


        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////////

        // ******************************
        //        Public methods
        // *****************************

        $scope.onEditTypeChange = (editType) => {
          $scope.editType = editType;
        }

        $scope.onSubmit = () => {
          self.$mdDialog.hide($scope.editType);
        }
      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  attachAgentToResource(resource, branchIds, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/attach-agent-to-resource-dialog.html').default,
      controller: function ($scope, $infiniteScroll, $agentResource) {

        $scope.agentResourceRef = $agentResource();
        $scope.loadLimit = 20;
        $scope.loading = true;
        $scope.resource = resource;
        $scope.selectedAgent = undefined;

        $scope.agentResourceRef.$query($scope._getQueryPayload());
        $scope.infiniteScroll = $infiniteScroll($scope.agentResourceRef, $scope.loadLimit, {getFullData: true});

        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////////

        // ******************************
        //        Public methods
        // ******************************

        $scope.onQueryChange = (query) => {
          $scope.queryString = query;
          $scope._query();
        }

        $scope.onAssign = (agentBinding) => {
          var payload = {
            agentId: agentBinding.id,
            resourceAllocationId: resource.id
          };

          self.$mdDialog.hide(payload);
        }

        // ******************************
        // Private methods
        // ******************************

        $scope._getQueryPayload = () => {
          return {
            limit: $scope.loadLimit,
            query: $scope.queryString,
            sortByLoad: true,
            active: true,
            agentType: resource.agentType,
            branchIds: branchIds
          }
        }

        $scope._query = () => {
          $scope.agentResourceRef.$query($scope._getQueryPayload())
            .then(() => {
              $scope.infiniteScroll.reload();
            })
            .catch((error) => {
              self.$log.error('Fail to $query', error);
            })
        }
      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  activeRoutes(resource?, routeIds?, event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/active-routes-dialog.html').default,
      controller: function ($scope) {

        $scope.resource = resource;
        $scope.routeIds = routeIds;
        $scope.queryString = undefined;

        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////////

        $scope.onQueryChange = (query) => {
          $scope.queryString = query;
        }

        $scope.submit = () => {
          self.$mdDialog.hide();
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  attachStopSequenceToAllocation(allocation, resource, range, branchIds, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/allocation-account-sequence-dialog-OLD.html').default,
      controller: function ($scope) {

        $scope.allocation = angular.copy(allocation);
        $scope.resource = resource;
        $scope.branchIds = branchIds;

        $scope.allocationRange = range;
        $scope.allocation.details = _.sortBy($scope.allocation.details, ['sequence']);

        if (!$scope.allocation.details) {
          $scope.allocation.details = [];
        }

        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////////

        $scope.onAccountSelect = (account, sequenceDetails, $index) => {
          if (account) {
            sequenceDetails.holderId = account.id;
          }
        }

        $scope.onAdd = () => {
          $scope.allocation.details.push({
            holderId: undefined,
            sequence: $scope.allocation.details.length + 1,
            type: "ACCOUNT"
          })
        }

        $scope.onRemove = ($index) => {
          $scope.allocation.details.splice($index, 1);
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              _.forEach($scope.allocation.details, (allocationDetail, i) => {
                allocationDetail.sequence = i + 1;
              })
              self.$mdDialog.hide($scope.allocation);
            }

          }
        }
      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  upload(event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/upload-resources-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope, agentConstants) {

        $scope.loading = false;
        $scope.agentTypes = agentConstants.types;
        $scope.skillsTypes = agentConstants.skillsByType['ServiceAgent'];

        $scope.defaultsForm = {
          agentType: $scope.agentTypes[0],
          skills: [agentConstants.skillsByType[$scope.agentTypes[0]][0]],
          vehicleId: undefined,
          file: undefined
        };

        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////

        $scope.onAgentTypeChange = (agentType) => {
          $scope.defaultsForm.agentType = agentType;
          $scope.defaultsForm.skills = agentType === AgentType.Driver ? ['Delivery'] : [$scope.skillsTypes[0]];
        }

        $scope.onSkillSelect = (skills) => {
          $scope.defaultsForm.skills = skills;
        }

        $scope.onVehicleSelect = (vehicle) => {
          $scope.defaultsForm.vehicleId = _.get(vehicle, 'id');
        }

        $scope.onAddFile = (file) => {
          $scope.defaultsForm.file = file;
        }

        $scope.onUpload = (form) => {
          if (form) {
            $scope.loading = true;
            self.$mdDialog.hide($scope.defaultsForm)
          } else {
            self.$log.error('Form resolved to undefined!. \n' +
              '--> adminDialogService@createNewAdmin  @submit')
          }
          $scope.loading = false;
        }
      }

    })

  }

  onBulkEditResourceAllocation(event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/edit-resource-allocation.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {

        $scope.data = {
          schedule: {
            startTime: undefined,
            endTime: undefined
          },
          extraTimeInMillis: undefined,
          gapInMinutes: undefined,
          freqType: 'All'
        }

        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////

        $scope.onDataChange = (data) => {
          $scope.data = {...data};
        }

        $scope.submit = () => {
          self.$mdDialog.hide($scope.data);
        }
      }

    })

  }

  onBulkEditResources(event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/bulk-edit-resource-dialog.html').default,
      controller: function ($scope, planningConstants) {
        $scope.payload = {
          isActive: null,
          gapInMinutes: null,
          blockManualRoute: null,
          blockPlanningRoute: null,
          blockQuoteRoute: null,
          considerMinimumRouteCostValue: null,
          minimumRouteCostValue: null,
          considerMaximumRouteCostValue: null,
          maximumRouteCostValue: null,
          considerMinimumRouteIncome: null,
          minimumRouteIncome: null,
          considerMaximumRouteIncome: null,
          maximumRouteIncome: null,
          optimizeStart: null,
          optimizeStartBufferMinutes: null,
          locationSettings: undefined
        };
        $scope.isLocationSettingsEnabled = null;

        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////////

        // ******************************
        //        Public methods
        // ******************************

        $scope.onLocationSettingsChange = (locationSettings) => {
          $scope.payload.locationSettings = locationSettings;
        }

        $scope.onToggleIsActive = (isActive) => {
          $scope.payload.isActive = isActive;

          // if (!$scope.resource.isActive) {
          //   $scope.resource.blockManualRoute = true;
          //   $scope.resource.blockPlanningRoute = true;
          //   $scope.resource.blockQuoteRoute = true;
          // } else {
          //   $scope.resource.blockManualRoute = false;
          //   $scope.resource.blockPlanningRoute = false;
          //   $scope.resource.blockQuoteRoute = false;
          // }
        }

        $scope.onToggleConsiderMinimumRouteCostValue = (considerMinimumRouteCostValue) => {
          $scope.payload.considerMinimumRouteCostValue = considerMinimumRouteCostValue;

          if (!considerMinimumRouteCostValue) {
            $scope.payload.minimumRouteCostValue = undefined;
          }
        }

        $scope.onToggleConsiderMaximumRouteCostValue = (considerMaximumRouteCostValue) => {
          $scope.payload.considerMaximumRouteCostValue = considerMaximumRouteCostValue;

          if (!considerMaximumRouteCostValue) {
            $scope.payload.maximumRouteCostValue = undefined;
          }
        }

        $scope.onToggleConsiderMinimumRouteIncome = (considerMinimumRouteIncome) => {
          $scope.payload.considerMinimumRouteIncome = considerMinimumRouteIncome;

          if (!considerMinimumRouteIncome) {
            $scope.payload.minimumRouteIncome = undefined;
          }
        }

        $scope.onToggleConsiderMaximumRouteIncome = (considerMaximumRouteIncome) => {
          $scope.payload.considerMaximumRouteIncome = considerMaximumRouteIncome;

          if (!considerMaximumRouteIncome) {
            $scope.payload.maximumRouteIncome = undefined;
          }
        }

        $scope.onToggleIsLocationSettingsEnabled = (isLocationSettingsEnabled) => {
          $scope.isLocationSettingsEnabled = isLocationSettingsEnabled;

          if (!isLocationSettingsEnabled) {
            $scope.payload.locationSettings = undefined;
          }
        }

        $scope.onChangeOptimizeStart = (optimizeStart) => {
          $scope.payload.optimizeStart = optimizeStart;
        }

        $scope.onToggleBlockResource = (resourceType) => {
          $scope.payload[resourceType] = !$scope.payload[resourceType];
          // $scope.payload.isActive = !$scope.payload.blockManualRoute || !$scope.payload.blockPlanningRoute || !$scope.payload.blockQuoteRoute
        }


        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {

              // In template the logic is for BLOCKED
              if ($scope.payload.isActive !== null) {
                $scope.payload.isActive = !$scope.payload.isActive;
              }

              // In template the logic is for ENABLED
              if ($scope.payload.blockManualRoute !== null) {
                $scope.payload.blockManualRoute = !$scope.payload.blockManualRoute;
              }
              if ($scope.payload.blockPlanningRoute !== null) {
                $scope.payload.blockPlanningRoute = !$scope.payload.blockPlanningRoute;
              }
              if ($scope.payload.blockQuoteRoute !== null) {
                $scope.payload.blockQuoteRoute = !$scope.payload.blockQuoteRoute;
              }

              self.$mdDialog.hide($scope.payload);
            }

          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })

  }

}

angular
  .module('bringoz.admin.resources')
  .service('resourcesDialogService', ResourcesDialogService);
